export enum EAlertType {
	success,
	warning,
	danger,
}
